
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.953 5.531h9.735l.882-1.093-.898-1.11H.953V2.29h8.922L8.625.797l.508-.43 3.82 3.82v.5l-3.82 3.82-.508-.429L9.883 6.57H.953V5.531z","fill":"currentColor"}})])
          )
        }
      }
    